import { v4 as uuidv4 } from "uuid";
const DEVICE_ID = "deviceId";

export function newUuid() {
  return uuidv4();
}
let localUniqueId: string | undefined | null;

export function getLocalUniqueId() {
  if (!localUniqueId) {
    try {
      localUniqueId = localStorage.getItem(DEVICE_ID);

      if (!localUniqueId || typeof localUniqueId !== "string") {
        localUniqueId = newUuid();
        localStorage.setItem(DEVICE_ID, localUniqueId);
      }
    } catch (err) {
      localUniqueId = newUuid();
    }
  }
  return localUniqueId;
}
